module.exports = __webpack_public_path__ + "static/media/bg-image-2.9e274cf9.jpg";